module.exports = __webpack_public_path__ + "static/media/menu-icon.6cda4176.svg";